import {lazy} from "react";
import {registerDefaultTaskDetail, registerTaskDetail} from "../hermes/tasks/taskDetailRegistry";

/**
 * Registers the commission + HSE task detail views into the generic task
 * detail registry. Imported eagerly at app bootstrap (from appConfig) so the
 * registry is populated before the /tasks/:task_id route renders. The views
 * themselves stay lazy, so registration is cheap and code-splitting is kept.
 */

// HSE tasks render the dedicated HSE document-validation view.
registerTaskDetail("HSE", lazy(() => import("../hermes/tasks/HseDocValidationTaskView")));

// Every partner-qualification task (checklist 231, due diligence, scorecard sign,
// questionnaire, contractualization) shares the QUALIFICATION context; the view
// dispatches on task.type internally.
registerTaskDetail("QUALIFICATION", lazy(() => import("../hermes/tasks/QualificationTaskView")));

// Every other commission context (CONSTRUCTION / ODL / ASSIGNMENT / ...) uses
// the commission task detail view.
registerDefaultTaskDetail(lazy(() => import("../hermes/commissions/board/CommissionTaskView")));
